import { useState, useEffect } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VideosPage() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchVideos();
  }, []);

  const fetchVideos = async () => {
    try {
      const res = await fetch(`${API}/videos`);
      if (res.ok) {
        setVideos(await res.json());
      }
    } catch (e) {
      console.error("Error fetching videos:", e);
    } finally {
      setLoading(false);
    }
  };

  const latestVideo = videos.find(v => v.category === 'latest') || videos[0];
  const popularVideo = videos.find(v => v.category === 'popular');
  const recommendedVideos = videos.filter(v => v.category === 'recommended');

  return (
    <div className="page-wrapper" data-testid="videos-page">
      <div className="myspace-container">
        {/* Header */}
        <div className="myspace-header">
          <h3>kezzio's videos</h3>
        </div>

        {loading ? (
          <div className="text-center text-[var(--text-white)] opacity-80 text-[11px] py-8">
            Loading videos...
          </div>
        ) : (
          <>
            {/* Latest Video */}
            {latestVideo && (
              <div className="myspace-section m-2" data-testid="latest-video-featured">
                <div className="myspace-section-title">:: Most Recent Video ::</div>
                <div className="myspace-section-content">
                  <div className="video-embed-2006 max-w-2xl mx-auto">
                    <iframe
                      src={`https://www.youtube.com/embed/${latestVideo.youtube_id}`}
                      title={latestVideo.title}
                      width="100%"
                      height="360"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </div>
                  <div className="text-[11px] text-[#ff6600] font-bold mt-3 text-center">
                    {latestVideo.title}
                  </div>
                </div>
              </div>
            )}

            {/* Popular Video */}
            {popularVideo && (
              <div className="myspace-section m-2" data-testid="popular-video">
                <div className="myspace-section-title">:: Most Popular ::</div>
                <div className="myspace-section-content">
                  <div className="video-embed-2006 max-w-xl mx-auto">
                    <iframe
                      src={`https://www.youtube.com/embed/${popularVideo.youtube_id}`}
                      title={popularVideo.title}
                      width="100%"
                      height="280"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </div>
                  <div className="text-[11px] text-[#ff6600] font-bold mt-3 text-center">
                    {popularVideo.title}
                  </div>
                </div>
              </div>
            )}

            {/* Recommended Videos */}
            {recommendedVideos.length > 0 && (
              <div className="myspace-section m-2" data-testid="recommended-videos">
                <div className="myspace-section-title">:: More Videos ::</div>
                <div className="myspace-section-content">
                  <div className="video-grid-2006">
                    {recommendedVideos.map((video, index) => (
                      <div key={video.id} className="border border-[var(--border-color)] p-2 bg-[var(--bg-body)]" data-testid={`recommended-video-${index}`}>
                        <div className="video-embed-2006">
                          <iframe
                            src={`https://www.youtube.com/embed/${video.youtube_id}`}
                            title={video.title}
                            width="100%"
                            height="180"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          />
                        </div>
                        <div className="text-[11px] text-[var(--text-link)] mt-2">{video.title}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {videos.length === 0 && (
              <div className="text-center text-[var(--text-white)] opacity-80 text-[11px] py-8">
                No videos yet. Check back soon!
              </div>
            )}
          </>
        )}

        {/* Footer */}
        <div className="text-center text-[10px] text-[var(--text-white)] opacity-60 py-3 border-t border-[var(--border-color)]">
          <a href="/" className="text-[var(--text-link)]">&laquo; Back to Home</a>
        </div>
      </div>
    </div>
  );
}
